import BaseOrder from "./BaseOrder";
import Requests from "./Requests";

export default class Plan extends BaseOrder {
  static entity = "plans";

  static fields() {
    return {
      annual_plan: this.attr({}),
      monthly_plan: this.attr({}),
      single_purchase: this.attr({}),
      registered_agent: this.attr({}),
      compliance_guard: this.attr({}),
      current_plus_pricing: this.attr({}),
    };
  }

  static async fetchAll() {
    const { data } = await this.axios.get(`/pricing`);
    Requests.markAsLoaded("plans");
    return this.create({ data });
  }
}
